/**
 * Build the shareable link for an org invite.
 *
 * Mirrors the backend's build_user_invite_link: /invite/:inviteId with the invitee
 * email as a query param so the accept page can lock the email field. Lets admins
 * share an invite directly when the invite email is filtered (non-prod), fails,
 * or lands in spam (ENG-6983).
 *
 * This is an unbranded link: today's invite system doesn't serve branded
 * (enterprise) accounts, so no brand param is attached. Revisit if that changes.
 */
export function buildInviteLink(origin: string, inviteId: string, inviteeEmail: string): string {
  const params = new URLSearchParams({ email: inviteeEmail })
  return `${origin}/invite/${inviteId}?${params.toString()}`
}
